import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setTokens as setTokensAction } from '@src/store/authentication/actions';
import { tokensSelector } from '@src/store/authentication/selectors';
import { Tokens } from '@src/store/authentication/types';

const useAuthenticationTokens = () => {
  const dispatcher = useDispatch();
  const selector = useSelector(tokensSelector);
  const setTokens = React.useCallback(
    (tokens: Tokens & { setupComplete?: boolean }) =>
      dispatcher(setTokensAction(tokens)),
    [dispatcher]
  );

  return React.useMemo(() => {
    return { tokens: selector, setTokens };
  }, [selector, setTokens]);
};

export default useAuthenticationTokens;
